import { styled } from '../../Utilities';
import { DialogFooterBase } from './DialogFooter.base';
import { getStyles } from './DialogFooter.styles';
export var DialogFooter = styled(DialogFooterBase, getStyles);
//# sourceMappingURL=DialogFooter.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/Dialog/DialogFooter.js
// module id = 141
// module chunks = 0